export default "__VITE_ASSET__CNoqcX98__"